import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { AltriSoggettiComponent } from 'src/app/anagrafiche/altri-soggetti/altri-soggetti.component';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => LiquidatorePickerComponent) },
  ],
  selector: 'liquidatore-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class LiquidatorePickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(AltriSoggettiComponent, {
      data: {
        selectionMode: true,
        defaultSearch: {
          tipo: new TipoAltroSoggetto().deserialize({
            nome: 'Liquidatore',
            id: 5,
          })
        }
      }
    }).afterClosed();
  };


  getRoute = (id) => `/altri-soggetti/${id}`;
}
